import { createSlice } from '@reduxjs/toolkit';

import type {
  RarDataAPIPagination,
  RarDataAPIReviewItem,
} from 'src/services/rar-data-api/types/RarDataAPIReviews';
import { logger } from 'src/utils/serverLogger';
import { requestProductReviews } from './thunks';

export type ReviewsPages = Record<number, RarDataAPIReviewItem[]> | null;

export interface ProductReviewsState {
  averageProductRating: number | null;
  error: boolean;
  numberOfReviews: number | null;
  pages: ReviewsPages;
  pagination: RarDataAPIPagination | null;
}

export const initialState: Readonly<ProductReviewsState> = {
  error: false,
  numberOfReviews: null,
  pages: null,
  pagination: null,
  averageProductRating: null,
};

export const { actions, reducer } = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestProductReviews.fulfilled, (state, { payload }) => {
        const { averageProductRating, numberOfReviews, pagination, reviews } = payload;

        state.pages = { ...(state.pages || {}), [pagination.currentPage]: reviews };
        state.pagination = { ...state.pagination, ...pagination };
        state.averageProductRating = averageProductRating || 0;
        state.numberOfReviews = numberOfReviews;
      })
      .addCase(requestProductReviews.rejected, (state, action) => {
        logger.error('Error requesting product reviews', action.error);
        state.pages = { ...(state.pages || {}) };
        state.error = true;
        state.averageProductRating = 0;
        state.numberOfReviews = 0;
      });
  },
});
